<script>
import EntityService from '@/services/entityService.js';

export default {
    name: 'ModalEditarDesenho',
    props: [
        "usuarioStore",
        "dado",
        "editandoDado",
        "controlesDesativados"
    ],
    emits: [
        "update:alteraDados",
        "update:alteraDado",
        "update:alteraEditandoDado"
    ],
    data() {
        return {
            formulario: {
                code: "",
                status: "Elaboração",
                CodeEqipment: "",
                typeEquipment: "",
                sizeDocument: "",
                pieceEquipment: "",
                destinyDsenho: "",
                fomatDocument: "",
                sequential: "",
                descriptionDes: "",
                numeroCliente: "",
                anexo: ""
            },
            salvando: false,
            statusOpcoes: [
                "Elaboração",
                "Elaborado",
                "Cancelado"
            ],
            formatoOpcoes: [
                "A0",
                "A1",
                "A2",
                "A3",
                "A4"
            ],
            destinoOpcoes: [
                "C – Cliente",
                "F – Fabricação",
                "M – Montagem"
            ],
            entityService: new EntityService('DesenhoNumber')
        };
    },
    computed: {
        numeracaoGerada() {
            // Se tem numeração, os campos ficam bloqueados
            return !!this.formulario.sequential;
        }
    },
    methods: {
        alteraDados() {
            this.$emit('update:alteraDados');
        },
        alteraDado(update) {
            this.$emit('update:alteraDado', update);
        },
        alteraEditandoDado(update) {
            this.$emit('update:alteraEditandoDado', update);
        },
        fecharModal() {
            this.alteraEditandoDado({ editandoDado: false, dado: {} });
        },
        carregarDado() {
            if (this.dado && (this.dado.id || this.dado.code)) {
                this.formulario = { ...this.dado };
            }
        },
        async salvarDesenho() {
            if (!this.formulario.id) {
                alert("Erro: Desenho sem ID");
                return;
            }

            try {
                this.salvando = true;
                await this.entityService.insertOrUpdate(this.formulario);
                alert("Desenho atualizado com sucesso!");
                this.alteraDados(); // Atualiza a lista
                this.fecharModal();
            } catch (error) {
                console.error("❌ Erro ao atualizar desenho:", error);
                alert("Erro ao atualizar desenho");
            } finally {
                this.salvando = false;
            }
        }
    },
    watch: {
        editandoDado(newVal) {
            if (newVal) {
                this.carregarDado();
            }
        },
        dado: {
            handler() {
                this.carregarDado();
            },
            deep: true
        }
    }
};
</script>

<template>
    <v-dialog
        :value="editandoDado"
        @input="fecharModal"
        max-width="900px"
        persistent
        :disabled="controlesDesativados"
    >
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-pencil</v-icon>
                Editar Desenho
            </v-card-title>

            <v-card-text class="pt-6">
                <!-- Alerta se numeração foi gerada -->
                <v-alert
                    v-if="numeracaoGerada"
                    type="info"
                    dense
                    outlined
                    class="mb-4"
                >
                    <strong>Atenção:</strong> A numeração já foi gerada. Os campos que compõem a numeração não podem ser alterados.
                </v-alert>

                <!-- Seção: Informações Básicas -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Informações Básicas</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="formulario.code"
                                label="ID"
                                readonly
                                outlined
                                dense
                                hide-details
                            />
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-select
                                v-model="formulario.status"
                                :items="statusOpcoes"
                                label="Status"
                                outlined
                                dense
                                hide-details
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.sequential"
                                label="Número do Desenho"
                                readonly
                                outlined
                                dense
                                hide-details
                            />
                        </v-col>
                    </v-row>
                </div>

                <!-- Seção: Dados da Numeração (bloqueados se já gerada) -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Dados da Numeração</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.CodeEqipment"
                                label="Código de Equipamento *"
                                outlined
                                dense
                                :readonly="numeracaoGerada"
                                :disabled="numeracaoGerada"
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.typeEquipment"
                                label="Tipo de Equipamento *"
                                outlined
                                dense
                                :readonly="numeracaoGerada"
                                :disabled="numeracaoGerada"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.sizeDocument"
                                label="Modelo ou Tamanho *"
                                outlined
                                dense
                                :readonly="numeracaoGerada"
                                :disabled="numeracaoGerada"
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.pieceEquipment"
                                label="Parte do Equipamento *"
                                outlined
                                dense
                                :readonly="numeracaoGerada"
                                :disabled="numeracaoGerada"
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formulario.destinyDsenho"
                                :items="destinoOpcoes"
                                label="Destino do Desenho *"
                                outlined
                                dense
                                :readonly="numeracaoGerada"
                                :disabled="numeracaoGerada"
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select
                                v-model="formulario.fomatDocument"
                                :items="formatoOpcoes"
                                label="Formato do Desenho *"
                                outlined
                                dense
                                :readonly="numeracaoGerada"
                                :disabled="numeracaoGerada"
                            />
                        </v-col>
                    </v-row>
                </div>

                <!-- Seção: Informações Adicionais (sempre editáveis) -->
                <div class="mb-4">
                    <h3 class="subtitle-1 mb-2">Informações Adicionais</h3>
                    <v-divider class="mb-4"></v-divider>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="formulario.descriptionDes"
                                label="Título / Descrição"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.numeroCliente"
                                label="Número do Cliente"
                                outlined
                                dense
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="formulario.anexo"
                                label="Link do Arquivo"
                                outlined
                                dense
                            />
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-card-actions class="pa-4 grey lighten-4">
                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click="fecharModal"
                    :disabled="salvando"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="primary"
                    @click="salvarDesenho"
                    :loading="salvando"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.subtitle-1 {
    font-weight: 600;
    color: #333;
}
</style>
